const Region = {
    Region: {
        en: "en",
        us: "en_US",
        ca: "fr_CA",
        tw: "en_TW",
    },
};

export default Region;
